/* header.js — <header-amc> (sticky, mega menu, gaveta em acordeão) e <predictive-search-amc>. Ver docs/FASE-2-HEADER-NAVEGACAO.md */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');

  /* ================= Header ================= */
  class HeaderAMC extends HTMLElement {
    connectedCallback() {
      this.megaBotao = this.querySelector('[data-mega-abrir]');
      this.mega = this.querySelector('[data-mega]');
      this.gaveta = this.querySelector('[data-gaveta]');
      this.iniciarSticky();
      this.iniciarMega();
      this.iniciarGaveta();
    }

    /* ----- Sticky inteligente ----- */
    iniciarSticky() {
      if (!this.classList.contains('site-header--sticky')) return;
      var ultimo = window.scrollY;
      var pendente = false;
      var self = this;
      var limite = function () { return self.offsetTop + self.offsetHeight; };
      window.addEventListener('scroll', function () {
        if (pendente) return;
        pendente = true;
        window.requestAnimationFrame(function () {
          var y = window.scrollY;
          var desceu = y > ultimo + 4;
          var subiu = y < ultimo - 4;
          if (y <= limite()) {
            self.classList.remove('is-recolhido', 'is-rolado');
          } else if (desceu && !self.temCamadaAberta()) {
            self.classList.add('is-recolhido', 'is-rolado');
          } else if (subiu) {
            self.classList.remove('is-recolhido');
            self.classList.add('is-rolado');
          }
          if (desceu || subiu) ultimo = y;
          pendente = false;
        });
      }, { passive: true });
    }

    temCamadaAberta() {
      return (this.mega && !this.mega.hidden) || (this.gaveta && this.gaveta.open);
    }

    /* ----- Mega menu ----- */
    iniciarMega() {
      if (!this.megaBotao || !this.mega) return;
      var self = this;
      var raiz = this.megaBotao.parentElement;
      var timer = null;

      // Clique depois de abrir por hover mantém aberto (evita abrir e fechar no mesmo gesto).
      this.megaBotao.addEventListener('click', function () {
        clearTimeout(timer);
        if (self.mega.hidden) self.abrirMega();
        else if (self.porHover) self.porHover = false;
        else self.fecharMega(true);
      });

      raiz.addEventListener('mouseenter', function () {
        if (!DESKTOP.matches || !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { if (self.mega.hidden) { self.abrirMega(); self.porHover = true; } }, 150);
      });
      raiz.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { self.fecharMega(false); }, 200);
      });

      raiz.addEventListener('focusout', function (e) {
        if (!raiz.contains(e.relatedTarget)) self.fecharMega(false);
      });

      document.addEventListener('click', function (e) {
        if (!self.mega.hidden && !raiz.contains(e.target)) self.fecharMega(false);
      });

      raiz.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.mega.hidden) {
          e.preventDefault();
          self.fecharMega(true);
          return;
        }
        var cat = e.target.closest('[data-mega-categoria]');
        var itens = Array.prototype.slice.call(self.mega.querySelectorAll('[data-mega-categoria]'));
        if (cat && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
          e.preventDefault();
          var i = itens.indexOf(cat) + (e.key === 'ArrowDown' ? 1 : -1);
          var alvo = itens[(i + itens.length) % itens.length];
          self.ativarCategoria(alvo);
          alvo.focus();
        } else if (cat && e.key === 'ArrowRight') {
          self.ativarCategoria(cat);
          var painel = cat.getAttribute('aria-controls') && document.getElementById(cat.getAttribute('aria-controls'));
          var primeiro = painel && painel.querySelector('a, button');
          if (primeiro) { e.preventDefault(); primeiro.focus(); }
        } else if (e.key === 'ArrowLeft' && e.target.closest('.mega__painel')) {
          var ativo = self.mega.querySelector('[data-mega-categoria][aria-current="true"]');
          if (ativo) { e.preventDefault(); ativo.focus(); }
        } else if (e.key === 'ArrowDown' && e.target === self.megaBotao) {
          e.preventDefault();
          self.abrirMega();
          if (itens[0]) { self.ativarCategoria(itens[0]); itens[0].focus(); }
        }
      });

      this.mega.querySelectorAll('[data-mega-categoria]').forEach(function (cat) {
        var ativar = function () { self.ativarCategoria(cat); };
        cat.addEventListener('mouseenter', ativar);
        cat.addEventListener('focus', ativar);
      });
    }

    ativarCategoria(cat) {
      var id = cat.getAttribute('aria-controls');
      if (!id) return;
      this.mega.querySelectorAll('[data-mega-categoria]').forEach(function (c) {
        if (c === cat) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      this.mega.querySelectorAll('.mega__painel').forEach(function (p) { p.hidden = p.id !== id; });
      if (id === 'Mega-veiculos') this.carregarVeiculos();
    }

    abrirMega() {
      if (!this.mega.hidden) return;
      this.mega.hidden = false;
      this.megaBotao.setAttribute('aria-expanded', 'true');
      var ativo = this.mega.querySelector('[data-mega-categoria][aria-current="true"]') || this.mega.querySelector('[data-mega-categoria][aria-controls]');
      if (ativo) this.ativarCategoria(ativo);
    }

    fecharMega(devolverFoco) {
      if (this.mega.hidden) return;
      this.mega.hidden = true;
      this.porHover = false;
      this.megaBotao.setAttribute('aria-expanded', 'false');
      if (devolverFoco) this.megaBotao.focus();
    }

    carregarVeiculos() {
      var alvo = this.querySelector('[data-mega-veiculos-lista]');
      if (!alvo || alvo.__carregado || !window.AMCSeletor) return;
      alvo.__carregado = true;
      window.AMCSeletor.carregar().then(function (idx) {
        var frag = document.createDocumentFragment();
        Object.keys(idx).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); }).forEach(function (m) {
          var grupo = document.createElement('div');
          grupo.className = 'mega__montadora';
          var titulo = document.createElement('p');
          titulo.className = 'label';
          titulo.textContent = m;
          var ul = document.createElement('ul');
          ul.setAttribute('role', 'list');
          Object.keys(idx[m]).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); }).forEach(function (mo) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.className = 'mega__sub';
            a.href = window.AMCVeiculo.urlResultado({ montadora: m, modelo: mo });
            a.textContent = mo;
            li.appendChild(a);
            ul.appendChild(li);
          });
          grupo.appendChild(titulo);
          grupo.appendChild(ul);
          frag.appendChild(grupo);
        });
        alvo.innerHTML = '';
        alvo.appendChild(frag);
      }).catch(function () { alvo.__carregado = false; });
    }

    /* ----- Gaveta mobile (acordeão) ----- */
    iniciarGaveta() {
      if (!this.gaveta) return;
      var self = this;
      var abrir = this.querySelector('[data-gaveta-abrir]');
      var fechou = function () {
        if (abrir) { abrir.setAttribute('aria-expanded', 'false'); abrir.focus(); }
      };
      if (abrir) abrir.addEventListener('click', function () {
        self.gaveta.showModal();
        abrir.setAttribute('aria-expanded', 'true');
        var primeiro = self.gaveta.querySelector('[data-gaveta-fechar]');
        if (primeiro) primeiro.focus();
      });
      this.gaveta.addEventListener('close', fechou);
      this.gaveta.addEventListener('click', function (e) {
        if (e.target === self.gaveta || e.target.closest('[data-gaveta-fechar]')) { self.gaveta.close(); return; }
        var botao = e.target.closest('[data-acordeao]');
        if (botao) { self.alternarGrupo(botao); return; }
        if (e.target.closest('[data-veiculo-abrir]')) self.gaveta.close();
      });
    }

    alternarGrupo(botao) {
      var painel = document.getElementById(botao.getAttribute('aria-controls'));
      if (!painel) return;
      var abrir = botao.getAttribute('aria-expanded') !== 'true';
      botao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      painel.hidden = !abrir;
    }
  }

  /* ================= Busca preditiva ================= */
  class PredictiveSearchAMC extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.painel = this.querySelector('[data-busca-painel]');
      this.status = this.querySelector('[data-busca-status]');
      this.limpar = this.querySelector('[data-busca-limpar]');
      this.carregando = this.querySelector('.busca__carregando');
      this.textos = {};
      var tpl = this.querySelector('template[data-busca-textos]');
      if (tpl) tpl.content.querySelectorAll('[data-t]').forEach(function (el) { this.textos[el.getAttribute('data-t')] = el.textContent.trim(); }, this);
      this.timer = null;
      this.controle = null;
      this.ativo = -1;
      var self = this;
      this.input.addEventListener('input', function () { self.aoDigitar(); });
      this.input.addEventListener('keydown', function (e) { self.teclado(e); });
      this.input.addEventListener('focus', function () { if (self.painel.innerHTML && self.input.value.trim().length > 1) self.abrir(); });
      this.limpar.addEventListener('click', function () {
        self.input.value = '';
        self.limpar.hidden = true;
        self.fechar();
        self.input.focus();
      });
      // Clique dentro do painel não tira o foco do campo (senão o painel fecha antes do clique).
      this.painel.addEventListener('mousedown', function (e) { e.preventDefault(); });
      this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.fechar(); });
    }

    aoDigitar() {
      var q = this.input.value.trim();
      this.limpar.hidden = !this.input.value;
      clearTimeout(this.timer);
      if (q.length < 2) { this.fechar(); return; }
      var self = this;
      this.timer = setTimeout(function () { self.buscar(q); }, 220);
    }

    buscar(q) {
      if (this.controle) this.controle.abort();
      this.controle = 'AbortController' in window ? new AbortController() : null;
      var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = raiz + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      var self = this;
      this.ocupado(true);
      fetch(url, { signal: this.controle ? this.controle.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) { self.ocupado(false); self.render(q, (d.resources && d.resources.results) || {}); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') self.ocupado(false); /* offline: mantém a busca normal */ });
    }

    ocupado(sim) {
      if (this.carregando) this.carregando.hidden = !sim;
      this.setAttribute('aria-busy', sim ? 'true' : 'false');
    }

    preco(valor) {
      var moeda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
      var n = parseFloat(valor);
      if (isNaN(n)) return '';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: moeda }).format(n); } catch (e) { return valor; }
    }

    render(q, res) {
      var produtos = res.products || [];
      var colecoes = res.collections || [];
      var t = window.themeStrings || {};
      var x = this.textos;
      var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var html = '';
      var id = this.painel.id;
      var self = this;
      if (!produtos.length && !colecoes.length) {
        html = '<div class="busca__vazio"><p class="busca__vazio-titulo">' + (t.buscaVazia || '') + '</p>' +
          (x.vazia_dica ? '<p class="busca__vazio-texto">' + x.vazia_dica + '</p>' : '') +
          '<div class="busca__vazio-acoes">' +
          (document.querySelector('[data-seletor-dialogo]') ? '<button type="button" class="button button--secondary button--sm" data-veiculo-abrir>' + (x.veiculo || '') + '</button>' : '') +
          '<a class="button button--outline button--sm" href="' + (x.url_catalogo || raiz + 'collections/all') + '">' + (x.catalogo || '') + '</a></div></div>';
      } else {
        html += '<ul class="busca__lista" role="listbox" aria-label="' + (t.buscaSugestoes || '') + '">';
        var i = 0;
        if (colecoes.length) {
          html += '<li class="busca__grupo" role="presentation">' + (x.categorias || '') + '</li>';
          colecoes.forEach(function (c) {
            html += '<li role="option" id="' + id + '-op' + i++ + '" aria-selected="false"><a class="busca__item busca__item--colecao" href="' + c.url + '" tabindex="-1"><span class="busca__item-titulo"></span></a></li>';
          });
        }
        if (produtos.length) {
          html += '<li class="busca__grupo" role="presentation">' + (x.produtos || '') + '</li>';
          produtos.forEach(function (p) {
            html += '<li role="option" id="' + id + '-op' + i++ + '" aria-selected="false"><a class="busca__item" href="' + p.url + '" tabindex="-1">' +
              (p.featured_image && p.featured_image.url ? '<img class="busca__img" src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="busca__img busca__img--vazia"></span>') +
              '<span class="busca__item-titulo"></span><span class="busca__item-preco">' + self.preco(p.price) + '</span></a></li>';
          });
        }
        html += '</ul>';
        html += '<a class="busca__ver-todos link" href="' + raiz + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last"></a>';
      }
      this.painel.innerHTML = html;
      var titulos = this.painel.querySelectorAll('.busca__item-titulo');
      colecoes.concat(produtos).forEach(function (r, k) { if (titulos[k]) titulos[k].textContent = r.title; });
      var verTodos = this.painel.querySelector('.busca__ver-todos');
      if (verTodos) verTodos.textContent = (t.buscaVerTodos || '').replace('__termo__', q);
      this.ativo = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.status.textContent = produtos.length + colecoes.length ? (t.buscaResultados || '').replace('__n__', produtos.length + colecoes.length) : (t.buscaVazia || '');
      this.abrir();
    }

    opcoesLista() { return Array.prototype.slice.call(this.painel.querySelectorAll('[role="option"]')); }

    teclado(e) {
      var ops = this.opcoesLista();
      if (e.key === 'Escape') {
        if (!this.painel.hidden) { e.preventDefault(); this.fechar(); }
        else if (this.input.value) { e.preventDefault(); this.input.value = ''; this.limpar.hidden = true; }
        return;
      }
      if (!ops.length || this.painel.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.ativo = (this.ativo + (e.key === 'ArrowDown' ? 1 : -1) + ops.length) % ops.length;
        ops.forEach(function (o, i) { o.setAttribute('aria-selected', i === this.ativo ? 'true' : 'false'); }, this);
        this.input.setAttribute('aria-activedescendant', ops[this.ativo].id);
        ops[this.ativo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.ativo > -1) {
        e.preventDefault();
        var a = ops[this.ativo].querySelector('a');
        if (a) window.location.href = a.href;
      }
    }

    abrir() {
      this.painel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    fechar() {
      this.painel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.ativo = -1;
    }
  }

  if (!customElements.get('header-amc')) customElements.define('header-amc', HeaderAMC);
  if (!customElements.get('predictive-search-amc')) customElements.define('predictive-search-amc', PredictiveSearchAMC);
})();
